import {
  AccountVuex,
  AccountVuexState,
} from "@/shared/vuex/store/account.vuex";
import { createStore } from "vuex";

export interface AuthPlatformState {
  account: AccountVuexState;
}

export default createStore<AuthPlatformState>({
  modules: {
    account: AccountVuex as any,
  },
});
